<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Event Details <mat-icon (click)="openEditDetailsDialog()" *ngIf="editModeSet" class="edit-icon">edit</mat-icon></h2>
  </div>
  <div class="section__body">
    <div class="section__content event__content">
        <div class="event__header">Date and Time:</div>
        <p>Start Date: {{ eventStartDateString }}</p>
        <p style="padding-bottom: 7px">Start Time: {{ eventStartTimeString }}</p>

        <p>End Date: {{ eventEndDateString }}</p>
        <p>End Time: {{ eventEndTimeString }}</p>

        <div class="event__new-item" *ngIf="aviationEvent.webinarRegistrationLink"><span class="event__item-heading">Event Registration: </span><a href="{{ contactWebAddress }}" target="_blank">{{ contactWebAddress }}</a></div>

        <div class="event__new-item" *ngIf="aviationEvent.informationWebsite"><span class="event__item-heading">{{ aviationEvent.websiteCustomLabel ? aviationEvent.websiteCustomLabel : 'Event Information' }}: </span><a href="{{ informationWebAddress }}" target="_blank">{{ informationWebAddress }}</a></div>

        <div class="event__new-item"><span class="event__item-heading">Event Type: </span>{{ aviationEventTypeDesc[aviationEventType[aviationEvent.typeId]] }}</div>

        <div class="event__new-item"><span class="event__item-heading">Cost: </span>{{ aviationEvent.cost || 'Unknown' }}</div>
    </div>
  </div>
</div>
